import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded'
import React from 'react'
import styled from 'styled-components'

export interface EditGlobalFiltersLinkProps {
  /** Present = renders as a clickable link that calls this and stops the
   *  click from bubbling further (it lives inside tooltips over other
   *  clickable chrome). Absent = renders as plain, non-clickable text —
   *  the caller decides whether to render this at all in that case; see
   *  `FilterCardAccentBar`'s doc comment for why "nothing to jump to"
   *  sometimes means omitting the whole clause instead. */
  onClick?: () => void
}

/**
 * The shared "Edit global filters" affordance shown inside every tooltip
 * that tells the user a filter card is read-only because it's a dashboard
 * global filter — the lock badge, the eye/✕ on an inherited `FilterCard`,
 * and the accent bar. One primitive so the three don't drift in wording or
 * layout.
 */
export const EditGlobalFiltersLink: React.FC<EditGlobalFiltersLinkProps> = ({
  onClick,
}) =>
  onClick ? (
    <LinkButton
      type="button"
      onClick={(e) => {
        e.stopPropagation()
        onClick()
      }}
    >
      <span style={{ textDecoration: 'underline' }}>Edit global filters</span>
      <NavigateNextRoundedIcon style={{ fontSize: '16px' }} />
    </LinkButton>
  ) : (
    'Edit global filters'
  )

const LinkButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  color: inherit;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 2px;
`
